/* eslint-disable */
/// This file is auto generated - do not edit manually
export const ColorPrefix = 'Website.Product.ProductVariants.VariantSection.ColorPrefix';
export const SizePrefix = 'Website.Product.ProductVariants.VariantSection.SizePrefix';
export const MiscellaneousPrefix = 'Website.Product.ProductVariants.VariantSection.MiscellaneousPrefix';
